module.exports = "https://assets.sonder.com/n/p/_next/static/images/ta_best_of_the_best-40366ad1e0221796327892f28dbb959b.png";